export const ROLE_TYPE = {
    PARTNER: 'partner',
    CLIENT: 'client',
    ROOT: 'mineral',
};
